import { sanitizeUrl } from './sanitize';

// A YouTube video id: 11 characters from [A-Za-z0-9_-].
const ID_RE = /^[A-Za-z0-9_-]{11}$/;
const YOUTUBE_HOSTS = ['youtu.be', 'youtube.com', 'youtube-nocookie.com'];

/**
 * The video id inside a YouTube link — youtu.be/ID, youtube.com/watch?v=ID, /embed/ID, /shorts/ID, /live/ID — or '' when the
 * link is not a clean https YouTube video link. A player is only ever built from an id that passed this.
 */
export function youtubeVideoId(link) {
    const clean = sanitizeUrl(link, { allowedHosts: YOUTUBE_HOSTS });
    if (!clean) return '';
    const u = new URL(clean);
    const host = u.hostname.toLowerCase().replace(/^(www|m)\./, '');
    let id = '';
    if (host === 'youtu.be') id = u.pathname.split('/')[1] || '';
    else if (u.pathname === '/watch') id = u.searchParams.get('v') || '';
    else id = u.pathname.match(/^\/(?:embed|shorts|live|v)\/([^/]+)/)?.[1] || '';
    return ID_RE.test(id) ? id : '';
}

/** The player address for a validated id — YouTube's privacy-enhanced domain (no cookies until the video is played). */
export const youtubeEmbedUrl = (id, { autoplay = true } = {}) => (
    `https://www.youtube-nocookie.com/embed/${id}?${autoplay ? 'autoplay=1&' : ''}rel=0&playsinline=1`
);
